module.exports = __webpack_public_path__ + "static/media/img2.d9dd816f.jpeg";